<template>
  <el-card>
    <div class="avatar-container">
      <img class="avatar" :src="child.avatar" alt="" />
      <div class="right">
        <div class="name">{{ child.child_name }}</div>
        <div class="age-sex">
          <span>{{ child.age }}</span>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
export default {
  props: {
    child: [Object]
  }
};
</script>
<style lang="scss" scoped>
.avatar-container {
  display: flex;
  .avatar {
    width: 100px;
    height: 100px;
    margin-right: 10px;
    border-radius: 50%;
  }
  .right {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // width: 100px;
    box-sizing: border-box;
    padding: 10px;
    flex: 1;
  }
  .name {
    font-size: 20px;
  }
  .age-sex {
    font-size: 16px;
    display: flex;
    justify-content: space-between;
    color: #333;
  }
}
</style>
